import { render, staticRenderFns } from "./materialData.vue?vue&type=template&id=6f8a9ce7&scoped=true&"
import script from "./materialData.vue?vue&type=script&lang=js&"
export * from "./materialData.vue?vue&type=script&lang=js&"
import style0 from "./materialData.vue?vue&type=style&index=0&id=6f8a9ce7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8a9ce7",
  null
  
)

export default component.exports